/**
   * AddCartButton，加购按钮，点击元素本身触发
   * 
   * Attributes:
   * @param {String} data-variant-id 产品变体 ID
   * @param {String} data-quantity 购买数量，可选，默认为1
   * 
   * @example 
   * ```html
   * <add-cart-button data-variant-id="{{ product.first_available_variant.id }}" data-quantity="1" class="button round">
   *   Add to cart
   *   {%- render 'loading-spinner' -%}
   * </add-cart-button>
   * ```
   */
if (!customElements.get('add-cart-button')) {
    class AddCartButton extends HTMLElement {
        // 标记
        _marks = {
            loading: "loading"
        };

        _shopify_features_script = document.querySelector("script[id='shopify-features']");
        _shopify_features_json = JSON.parse(this._shopify_features_script.innerHTML);
        _checkout_headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': 'Basic ' + btoa(this._shopify_features_json.accessToken)
        };

        get _variantId() { return this.getAttribute("data-variant-id") }
        get _quantity() { return this.getAttribute("data-quantity") ?? 1 }

        constructor() {
            super();
        }

        connectedCallback() {
            this.elements = {
                loadingSpinner: this.querySelector(".loading__spinner"),
            };
            this.addEventListener('click', (e) => {
                this.startLoading();
                this.addToCart().finally(() => {
                    this.finishLoading();
                });
            });
        }

        /**
         * 加购
         */
        async addToCart() {

            const variantIds = this._variantId.split(',');

            const items = variantIds.map(id => {
                return {
                    'form_type': "product",
                    'utf8': "✓",
                    'id': parseInt(id, 10),
                    'quantity': this._quantity,
                };
            });

            let data_json = {
                'items': items
            };

            let data = JSON.stringify(data_json);
            return fetch("/cart/add.json",
                {
                    method: 'POST',
                    headers: this._checkout_headers,
                    body: data
                }
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                }
            }).then((response) => {
                return this.updateCart();
            }).then(() => {
                return this.openCart();
            })
            .catch((err) => {
                console.error(err);
            });
        }

        /**
         * 更新购物车，并弹出侧边购物车
         * @returns 
         */
        async fetchContent(url) {
            const response = await fetch(url, { method: 'GET' });

            // 检查响应是否成功
            if (!response.ok) {
                // console.error(`请求失败，无法加载内容: ${response.status}`);
                return null;
            }

            return await response.text(); // 获取响应的文本内容
        }

        updateElementContent(selector, content) {
            const targetElement = document.querySelector(selector);
            if (targetElement) {
                targetElement.innerHTML = content;  // 更新元素内容
                // console.log(`已更新元素：${selector}`);
            } else {
                // console.error(`未找到元素: ${selector}`);
            }
        }

        async updateCart() {
            // 获取当前页面 URL 和最终 URL
            const currentUrl = window.location.href;
            const targetElementId = 'cart-drawer';
            const bubbleElementContainerId = 'header';
            const bubbleElementId = 'cart-icon-bubble';
            const finalCartUrl = `${currentUrl}?&section_id=${targetElementId}`;
            const finalBubbleUrl = `${currentUrl}?&section_id=${bubbleElementContainerId}`;

            // console.log('最终请求的 URL (购物车部分):', finalCartUrl);
            // console.log('最终请求的 URL (气泡部分):', finalBubbleUrl);

            // 获取购物车部分内容并更新
            const cartContent = await this.fetchContent(finalCartUrl);
            if (cartContent) {
                this.updateElementContent(`#shopify-section-${targetElementId}`, cartContent);
            }

            // 获取气泡部分内容并更新
            const bubbleContent = await this.fetchContent(finalBubbleUrl);
            if (bubbleContent) {
                // 使用 DOMParser 提取气泡部分
                const bubbleElement = new DOMParser().parseFromString(bubbleContent, 'text/html').querySelector(`#${bubbleElementId}`);
                if (bubbleElement) {
                    const targetBubbleElement = document.querySelector(`#${bubbleElementId}`);
                    if (targetBubbleElement) {
                        targetBubbleElement.innerHTML = bubbleElement.innerHTML;  // 更新气泡内容
                        // console.log('已更新气泡内容');
                    } else {
                        // console.error('未找到气泡元素，无法更新');
                    }
                } else {
                    // console.error('无法找到气泡部分');
                }
            }
        }

        openCart(){
            const cartDrawer = document.querySelector('cart-drawer');
            const body = document.querySelector('body');
            if (cartDrawer) {
                cartDrawer.classList.add('active');
                body.classList.add('overflow-hidden');
            }
        }

        startLoading() {
            this.setAttribute("aria-disabled", true);
            this.classList.add(this._marks.loading);
            this.elements.loadingSpinner?.classList.remove("hidden");
        }

        finishLoading() {
            this.removeAttribute("aria-disabled");
            this.classList.remove(this._marks.loading);
            this.elements.loadingSpinner?.classList.add("hidden");
        }
    }

    customElements.define('add-cart-button', AddCartButton);
}